// extracted by mini-css-extract-plugin
export var divider = "_kt-0";
export var systemMessage = "_kt-1";
export var systemMessageWrapper = "_kt-2";